import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'
import { GatsbyImage } from 'gatsby-plugin-image'
import { DisplayOnDesktop } from '../../Cart/styles'

export const PopupBox = styled.div`
  background-color: ${(props) => props.theme.cream};
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  max-width: 830px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  position: relative;
  @media (max-width: ${breakpoints.m}px) {
    padding: 16px;
  }
`
export const PopupContainer = styled(PopupBox)`
  padding: 42px 48px 36px;
  b {
    font-family: 'FilsonProBold';
  }
  @media (max-width: ${breakpoints.m}px) {
    padding: 24px;
  }
  @media (max-width: ${breakpoints.s}px) {
    padding: 24px 16px 16px;
  }
`
export const Heading = styled.h2`
  font-family: 'FilsonProMedium';
  font-size: 20px;
  color: #000;
  margin: 0px;
  line-height: 120%;
  margin-bottom: 16px;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 20px;
    width: 100%;
  }
`
export const SubHeading = styled.h3`
  font-family: 'FilsonProBook';
  line-height: 140%;
  color: #000;
  margin-bottom: 32px;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 15px;
    margin-bottom: 16px;
  }
`
export const Text = styled.p`
  font-family: 'FilsonProBook';
  color: #000;
  font-size: 12px;
  line-height: 140%;
  margin: ${(props) => (props.noMargin ? '0px' : '8px auto')};
  @media (max-width: ${breakpoints.s}px) {
    font-size: 12px;
    margin-top: 4px;
    text-align: center;
    margin-bottom: 0px;
  }
  @media (max-width: 360px) {
    line-height: 1.2;
  }
`
export const TextLarge = styled.p`
  font-family: 'FilsonPro';
  font-size: 16px;
  color: #000;
  margin: 0px 0px 4px;
  @media (max-width: ${breakpoints.m}px) {
    margin: 0px 16px 8px !important;
  }
`
export const TextMedium = styled.p`
  font-family: 'FilsonPro';
  font-size: 12px;
  color: #000;
  margin: 0px;
  s {
    color: #666;
  }
  line-height: 1.2;
  margin-bottom: 8px;
`

export const Recommended = styled.h3`
  font-family: 'FilsonProMedium';
  font-size: 20px;
  color: #000;
  margin: 0px;
  line-height: 120%;
  br {
    display: inline;
  }
  s {
    text-decoration: line-through;
  }
  span {
    color: ${(props) => props.theme.coral};
  }
  @media (max-width: ${breakpoints.m}px) {
    br {
      display: none;
    }
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 14px;
    text-align: center;
  }
  @media (max-width: 370px) {
    font-size: 13px;
  }
  @media (max-width: 340px) {
    font-size: 12px;
  }
`
export const CalendarImage = styled.div`
  width: 100%;
  margin: 24px auto;
  position: relative;
  .desktop-only {
    display: block;
    @media (max-width: ${breakpoints.s}px) {
      display: none;
    }
  }
  .mobile-only {
    display: none;

    @media (max-width: ${breakpoints.s}px) {
      display: block;
    }
  }
`
export const CtaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  @media (max-width: ${breakpoints.s}px) {
    padding-top: 16px;
  }
`

export const TextContainer = styled.div`
  position: absolute;
  max-width: 280px;
  border-radius: 28px;
  top: 8px;
  padding: 18px;
  margin: 14px;
  background-color: rgba(255, 255, 255, 0.9);
  @media (max-width: ${breakpoints.m}px) {
    max-width: 90%;
    left: 0;
    right: 0;
    margin: 8px auto auto;
    padding: 14px;
  }
  @media (max-width: 360px) {
    padding: 14px 12px;
  }
`
export const ThreeColumnContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr 3fr;
  align-items: flex-start;
  gap: 16px;
  @media (max-width: ${breakpoints.m}px) {
    grid-template-columns: 1fr 2fr;
    align-items: center;
  }
`
export const ProductImage = styled(GatsbyImage)`
  width: 180px;
  img {
    border-radius: 8px;
  }
  @media (max-width: 370px) {
    width: 120px;
  }
`
export const MobileCtaContainer = styled(CtaContainer)`
  display: none;
  @media (max-width: ${breakpoints.m}px) {
    display: flex;
    position: absolute;
    bottom: 16px;
    padding: 0px 16px;
  }
`
export const ShowOnDesktop = styled(DisplayOnDesktop)`
  margin-top: 0px;
`
